import React, { Component } from "react";
import { getDocumentPath } from "../../../../utils/apis.js"
import Dialog from "../../../dialogs/dialog.js";
import { SimplePdfViewer } from "../../../../components/bases/simplepdfviewer/simplepdfviewer.js";






import "./assetsmanager.css"



class DisplayDocument extends Dialog
{
  constructor(props) 
  {
    super(props);

    this.shortcuts_list = [];

    const title = {
        fr: this.props.asset.astitle,
        en: this.props.asset.astitle,
      };

    this.state.title = title;
    this.state.documentpath  = getDocumentPath(this.props.asset) ;

    this.state.buttons = 
    [
      {type:"back", disabled:false},
      
    ]

    this.handleButton =  this.handleButton.bind(this);

    this.onQuit = this.onQuit.bind(this)
    
  }




  onQuit()
  {
    this.props.onButton("back");    
  }


  handleButton(buttonkey)
  {
    console.log("on click", buttonkey)
    if (buttonkey === "back")
        this.props.onButton("back");
    
  }

  
  render()
  {
    var maxwidth =  (window.innerWidth * 60)/100;
    if (maxwidth > 800) maxwidth = 800;

    var maxheight =  (window.innerHeight * 75)/100;
    if (maxheight > 500) maxheight = 500;


    var retour = (
      <div style = {{width:maxwidth, height: maxheight}}>
      </div>
    );

    if (this.props.display) 
    {

        retour =
        (
          <div style = {{width:maxwidth, height: maxheight}}>
            
                <SimplePdfViewer url={this.state.documentpath}/>
          </div>
        )
      }
    return super.render(retour);
  }


}


export default DisplayDocument;